module.exports = __webpack_public_path__ + "img/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-2.ea25507d.jpg";